export { IconTooltip } from './IconTooltip';
